<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-10">
          <div>
            <h2 class="primary--text">Configurações</h2>
            <v-divider class="my-2"></v-divider>
          </div>
          <v-row class="justify-center justify-md-start">
            <v-col cols="col-12 col-md-5">
              <v-list-item
                @click="
                  item.title == 'Excluir'
                    ? ($refs.downloadModal.$data.isActive = true)
                    : toPage(item)
                "
                class="lightGray mt-3 custom-radius"
                v-for="item in listMenu"
                :key="item.id"
              >
                <v-list-item-content>
                  <v-list-item-title class="gray--text font-bold">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-dialog ref="modal" v-model="modal" max-width="400px" class="dialog-consult">
        <v-card class="dialog-consult">
          <header>
            <h1>Tem certeza que deseja excluir sua conta?</h1>
          </header>
          <footer>
            <button @click="$refs.modal.$data.isActive = false">CANCELAR</button>
            <button class="delete" @click="deleteUser()">EXCLUIR</button>
          </footer>
        </v-card>
      </v-dialog>

      <v-dialog
        ref="downloadModal"
        v-model="downloadModal"
        max-width="400px"
        class="dialog-records"
      >
        <v-card class="dialog-records">
          <header>
            <h1>
              Ao excluir sua conta você perderá o acesso aos prontuários dos pacientes, deseja fazer
              download antes da exclusão?
            </h1>
          </header>
          <footer>
            <button @click="cancelMedicalRecords()">Excluir</button>
            <button class="medical-records" @click="goMedicalRecords()">Ir para prontuários</button>
          </footer>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :color="resultSnack" :timeout="3000">
        Usuário excluído com sucesso
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import StaticService from '../services/general';
import Api from '../services/httpClient';

export default {
  data() {
    return {
      listMenu: [],
      snackbar: false,
      resultSnack: '',
      downloadModal: '',
      modal: '',
    };
  },
  created() {
    this.getListMenu();
  },
  methods: {
    toPage(item) {
      if (item.content !== '') {
        this.$router.push(`others/${item.id}`);
      } else {
        window.open(item.link, '_blank');
      }
    },
    async getListMenu() {
      try {
        const results = await StaticService.listPageStatic();
        this.listMenu = results;
      } catch (error) {
        console.log(error);
      }
    },

    cancelMedicalRecords() {
      this.$refs.downloadModal.$data.isActive = false;
      this.$refs.modal.$data.isActive = true;
    },

    goMedicalRecords() {
      this.$router.push('/psicologo/historico-pacientes');
    },

    async deleteUser() {
      this.$refs.modal.$data.isActive = false;
      this.snackbar = true;
      try {
        await Api.delete('/delete-user');
        localStorage.clear();
        this.$router.replace('/');
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.w-100 {
  width: 100%;
}

.custom-radius {
  border-radius: 8px;
}

.font-bold {
  font-weight: bold;
}

.dialog-records,
.dialog-consult {
  height: 200px;
  padding: 30px 0;
  display: grid;
  align-items: center;
  justify-items: center;
}

.dialog-records {
  height: 250px;
}

.dialog-records h1 {
  font-size: 18px;
}

.dialog-consult h1 {
  font-size: 20px;
}

.dialog-records h1,
.dialog-consult h1 {
  color: #941d19;
  padding: 0 10px;
  text-align: center;
}

.dialog-records footer,
.dialog-consult footer {
  height: 65%;
  display: flex;
  justify-content: space-between;
}

.dialog-consult footer {
  width: 60%;
}

.dialog-records footer {
  width: 75%;
}

.dialog-records button,
.dialog-consult button {
  width: 48%;
  font-weight: 600;
  height: 100%;
  border: 1px solid #707070;
  border-radius: 5px;
  color: #6f6f6f;
  margin-bottom: 10px;
}

.dialog-records .medical-records,
.dialog-consult .delete {
  color: #ffffff;
  border: none;
}

.dialog-consult .delete {
  background-color: #db2828;
}

.dialog-records .medical-records {
  background-color: #45a655;
}

@media screen and (max-width: 400px) {
  .dialog-records {
    height: 290px;
  }

  .dialog-records footer,
  .dialog-consult footer {
    width: 80%;
  }

  .dialog-records footer {
    height: 80%;
  }
}
</style>
